import { Injectable } from '@angular/core';

/**
 * Loads the Qualtrics Website Feedback (Site Intercept) embed on the final
 * confirmation page.
 *
 * Mirrors the vendor snippet: append the SIE script to `document.body` once
 * the document is ready, and ensure the `Q_ZID` container div exists.
 */
@Injectable({ providedIn: 'root' })
export class QualtricsScriptLoaderService {
  private static readonly SCRIPT_ID = 'qualtrics-website-feedback';
  private static readonly INTERCEPT_URL =
    'https://zn2zqugaswyok3jvf-creditacceptance.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_2ZQuGasWYOK3jvf';

  private loaded = false;

  load(): void {
    if (this.loaded) return;

    const scriptSrc = QualtricsScriptLoaderService.INTERCEPT_URL;
    const containerId = this.getContainerId(scriptSrc);
    if (!containerId) {
      console.warn(
        '[qualtrics] INTERCEPT_URL is missing a Q_ZID query param; intercept not loaded.'
      );
      return;
    }

    this.ensureContainer(containerId);
    this.injectScript(scriptSrc);
    this.loaded = true;
  }

  private getContainerId(scriptSrc: string): string | null {
    try {
      return new URL(scriptSrc).searchParams.get('Q_ZID');
    } catch {
      return null;
    }
  }

  private ensureContainer(containerId: string): void {
    if (document.getElementById(containerId)) return;

    const container = document.createElement('div');
    container.id = containerId;
    document.body.appendChild(container);
  }

  private injectScript(scriptSrc: string): void {
    const appendScript = () => {
      if (document.getElementById(QualtricsScriptLoaderService.SCRIPT_ID)) {
        return;
      }

      const script = document.createElement('script');
      script.id = QualtricsScriptLoaderService.SCRIPT_ID;
      script.type = 'text/javascript';
      script.src = scriptSrc;
      document.body.appendChild(script);
    };

    if (document.readyState === 'complete') {
      appendScript();
      return;
    }

    window.addEventListener('load', appendScript, { once: true });
  }
}
